import { render, staticRenderFns } from "./PointSummaryItems.vue?vue&type=template&id=66c8678f"
import script from "./PointSummaryItems.vue?vue&type=script&lang=js"
export * from "./PointSummaryItems.vue?vue&type=script&lang=js"
import style0 from "./PointSummaryItems.vue?vue&type=style&index=0&id=66c8678f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports